import { type MCPServerInfo } from '../../types';

const FilesystemServer: MCPServerInfo = {
  serverId: 'FILESYSTEM',
  name: 'Filesystem',
  slug: 'filesystem',
  description:
    "Runs locally on the user's machine and allows the user to browse and search the files on their machine.",
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => {
      const directories = (config.allowedDirectories || '')
        .split(',')
        .map((dir) => dir.trim())
        .filter(Boolean)
        .map((dir) => {
          return dir.replace(/^['"]|['"]$/g, '');
        });

      return {
        command: 'npx',
        args: ['-y', '@modelcontextprotocol/server-filesystem@latest', ...directories],
        env: {}
      };
    }`
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['allowedDirectories'],
    properties: {
      allowedDirectories: {
        type: 'string',
        description:
          'Comma separated values of allowed directories. Please enter full paths.',
        sensitive: false
      }
    }
  }
};

export default FilesystemServer;
